<prt-template [isDemo]="isDemo" [today]="today" [plan]="currentCase">
	<div class="row">
		<div class="col-4">
			<div class="wrapper-print-tab">
				<h4>{{ labels().DRAWER_COMPONENT_TITLE_DEFORMITY }}</h4>
			</div>

			@if (hasAP) { <prt-ma-ap-table /> }
			@if (hasLT) { <prt-ma-lt-table /> }

		</div>
		<div class="col-8">
			<div class="wrapper-print-tab">
				<h4>{{ labels().PRINT_XRAY_IMAGE_TITLE }}</h4>
			</div>
			<div class="wrapper-canvas">
				<img [src]="printResult?.deformity" alt="deformity img" width="850" height="750" />
			</div>
		</div>
	</div>
</prt-template>